var map = {
	"./air-nga-en/styles/index.js": 26390,
	"./ais-tai-en/styles/index.js": 40897,
	"./ais-tai-tha/styles/index.js": 24587,
	"./demo-arabic/styles/index.js": 17979,
	"./demo-et-en/styles/index.js": 73954,
	"./demo-romanian/styles/index.js": 18830,
	"./demo-um-en/styles/index.js": 97145,
	"./dtac-tai-en/styles/index.js": 49802,
	"./dtac-tai-tha/styles/index.js": 22478,
	"./ethiotel-et-amh/styles/index.js": 34174,
	"./ethiotel-et-en/styles/index.js": 33523,
	"./mtn-cg-fr/styles/index.js": 69838,
	"./mtn-ci-fr/styles/index.js": 29760,
	"./mtn-cmr-fr/styles/index.js": 93210,
	"./mtn-gha-en/styles/index.js": 33031,
	"./mtn-nga-en/styles/index.js": 38971,
	"./mtn-zam-en/styles/index.js": 25057,
	"./saf-ke-en/styles/index.js": 91584,
	"./saudi-uae-en/styles/index.js": 86205,
	"./tlk-za-en/styles/index.js": 88432,
	"./vc-za-en/styles/index.js": 94038
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19035;